import { ChakraProvider } from "@chakra-ui/react";
import { StrictMode } from "react";
import { BrowserRouter } from "react-router-dom";

import { createRoot } from "react-dom/client";
import { store } from "@state/store";
import { Provider } from "react-redux";

import { App } from "./App";

const container = document.querySelector("#root") as HTMLElement;
const root = createRoot(container);

root.render(
  <StrictMode>
    <ChakraProvider>
      <Provider store={store}>
        <BrowserRouter
          future={{
            v7_startTransition: false,
            v7_relativeSplatPath: false,
          }}
        >
          <App />
        </BrowserRouter>
      </Provider>
    </ChakraProvider>
  </StrictMode>
);
